import { SAccordionStacked } from '@avalara/skylab-sdk/react';
import type { ReactNode } from 'react';

import { BlueHeading } from './accordion-styled-components';

type Props = {
  children: ReactNode;
  show: boolean;
  onToggle?: () => void;
  title: string;
  isBlueHeading?: boolean;
};

const Accordion = ({ children, show, onToggle, title, isBlueHeading = false }: Props) => (
  <SAccordionStacked open={show} onS-toggle={onToggle}>
    {isBlueHeading ? (
      <BlueHeading slot='title' className='font-bold'>
        {title}
      </BlueHeading>
    ) : (
      <h2 slot='title' className='alt'>
        {title}
      </h2>
    )}
    {children}
  </SAccordionStacked>
);
export default Accordion;
